// extracted by mini-css-extract-plugin
export default {"visuallyHidden":"SWajEb"};